import type { SecretType } from '@/modules/secrets';
import type { TRuleWithTheme } from '@/styles/theme';

export const icon: TRuleWithTheme<{ type: SecretType }> = ({ theme, type }) => ({
    color: theme.colors.secretType[type],
    lineHeight: 0,
});
